import TransactionDetails from "../Components/TransactionDetails";

function Show() {
  return (
    <div className="show pl-3">
      <TransactionDetails />
    </div>
  );
}

export default Show;
